//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getFieldDataSelect, getDataChange } from '@/api/onlineDev/visualDev';
export default {
  name: 'PopupSelect',
  props: {
    value: {
      default: ''
    },
    modelId: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    relationField: {
      type: String,
      default: ''
    },
    field: {
      type: String,
      default: ''
    },
    columnOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data: function data() {
    return {
      list: [],
      filteredList: [],
      innerValue: '',
      keyword: '',
      checked: '',
      checkedTxt: '',
      listLoading: false,
      visible: false
    };
  },
  watch: {
    value: function value(val) {
      this.setDefault();
    }
  },
  created: function created() {
    this.getData();
  },
  methods: {
    getData: function getData() {
      var _this = this;
      if (!this.modelId || !this.relationField) return;
      this.listLoading = true;
      getFieldDataSelect(this.modelId).then(function (res) {
        _this.list = res.data;
        _this.filteredList = _this.list;
        _this.listLoading = false;
        _this.setDefault();
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    search: function search() {
      var _this2 = this;
      if (!this.keyword) {
        this.filteredList = this.list;
        return;
      }
      this.filteredList = this.list.filter(function (o) {
        return _this2.columnOptions.some(function (option) {
          return option.value && o[option.value] && o[option.value].indexOf(_this2.keyword) > -1;
        });
      });
    },
    reset: function reset() {
      this.keyword = '';
      this.filteredList = this.list;
    },
    refresh: function refresh() {
      this.keyword = '';
      this.getData();
    },
    openDialog: function openDialog() {
      if (this.disabled) return;
      this.keyword = '';
      this.checked = this.value;
      this.visible = true;
      if (!this.list.length) {
        this.getData();
      } else {
        this.filteredList = this.list;
      }
    },
    clear: function clear() {
      this.checked = '';
      this.innerValue = '';
      this.$emit('input', this.checked);
      this.$emit('change', this.checked);
    },
    select: function select() {
      if (!this.checked) return;
      this.innerValue = this.checkedTxt;
      this.$emit('input', this.checked);
      this.$emit('change', this.checked);
      this.visible = false;
    },
    rowClick: function rowClick(row) {
      this.checked = row.id;
      this.checkedTxt = row[this.relationField];
    },
    setDefault: function setDefault() {
      if (!this.value) return this.innerValue = '';
      this.getItemValue(this.value);
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].id === this.value) {
          this.innerValue = this.list[i][this.relationField];
          break;
        }
      }
    },
    getItemValue: function getItemValue(val) {
      var _this3 = this;
      if (!this.field || !this.modelId) return;
      var relationData = this.$store.state.generator.relationData;
      if (val) {
        getDataChange(this.modelId, val).then(function (res) {
          if (!res.data || !res.data.data) return;
          var data = JSON.parse(res.data.data);
          _this3.$set(relationData, _this3.field, data);
          _this3.$store.commit('generator/UPDATE_RELATION_DATA', relationData);
        });
      } else {
        this.$set(relationData, this.field, {});
        this.$store.commit('generator/UPDATE_RELATION_DATA', relationData);
      }
    }
  }
};